import { render, staticRenderFns } from "./PhoneOff.vue?vue&type=template&id=470207e1"
import script from "./PhoneOff.vue?vue&type=script&lang=js"
export * from "./PhoneOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports